import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useURLs} from 'brandHooks/useURLs';

import {ICustomerCareWidgetProps} from './ICustomerCareWidget';
import messages from './messages';

import styles from './CustomerCareWidget.module.scss';

const CustomerCareWidget = ({classNames, isReversedWidget = false}: ICustomerCareWidgetProps) => {
	const intl = useIntl();
	const urls = useURLs();

	return (
		<div
			className={cn(classNames, styles['customer-care-widget'], {
				[styles['customer-care-widget--reversed']]: isReversedWidget,
			})}
		>
			<span className={styles['customer-care-widget__service']}>
				{intl.formatMessage(messages.firstLine, {
					serviceText: (chunk) => (
						<span className={styles['customer-care-widget__service-text']}>{chunk}</span>
					),
					ctaText: (chunk) => <span className={styles['customer-care-widget__service-link']}>{chunk}</span>,
					cta: (chunk) => (
						<a className={styles['customer-care-widget__service-link--a']} href={urls.CUSTOMER_SERVICE}>
							{chunk}
						</a>
					),
				})}
			</span>
			<span className={styles['customer-care-widget__care']}>
				{intl.formatMessage(messages.secondLine, {
					hours: (chunk) => <span className={styles['customer-care-widget__care-hours']}>{chunk}</span>,
				})}
			</span>
		</div>
	);
};

export default CustomerCareWidget;
